const STORE_NETWORK_JOURNEY_STORAGE_KEY = 'store-network-journey-id'
const STORE_NETWORK_ACCESS_QUERY_PARAMS = [
  'target_global_store_id',
  'target_product_id',
  'journey_id',
] as const

export const getStoreNetworkJourneyId = () => {
  const existing = sessionStorage.getItem(STORE_NETWORK_JOURNEY_STORAGE_KEY)
  if (existing && /^[0-9a-f-]{36}$/i.test(existing)) return existing
  const created = crypto.randomUUID()
  sessionStorage.setItem(STORE_NETWORK_JOURNEY_STORAGE_KEY, created)
  return created
}

export const preserveStoreNetworkAccessSearch = (search: string | null | undefined) => {
  const source = new URLSearchParams(String(search ?? ''))
  const preserved = new URLSearchParams()

  STORE_NETWORK_ACCESS_QUERY_PARAMS.forEach((key) => {
    const value = source.get(key)?.trim()
    if (value) preserved.set(key, value)
  })

  const serialized = preserved.toString()
  return serialized ? `?${serialized}` : ''
}
